import React, { useReducer } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
  additionalActions,
} from "@screens/system/settings/setting-list/setting.list.constants";
import SettingListTemplateComponent from "./setting.list.template";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteSettingsDataApi,
  getSettingsDataApi,
} from "./setting.list.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import { settingReducer } from "./setting.list.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { END_POINT } from "@constants/api.constants";

const { LOG_FILE_EXPORT } = END_POINT;
const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SETTINGS_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const initialStates = {
  tableData: [],
  totalCount: 0,
};

const SettingListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [states, stateDispatch] = useReducer(settingReducer, initialStates);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const { tableData, totalCount } = states;
  const { token } = useSelector((state) => state.app);

  const getSettingsData = async (params = null) => {
    const queryStr = getFilterQueryString(menuUrl, params);
    const settingData = await getSettingsDataApi({
      ...params,
      filters: queryStr,
    });
    if (settingData.status) {
      stateDispatch({
        type: "SET_TABLE_DATA",
        payload: { data: settingData.data, totalCount: settingData.totalCount },
      });
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteSettingsDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getSettingsData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };
  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    console.log("download triggered", filters, queryStr);
    window.open(`${LOG_FILE_EXPORT}?token=${token}`);
  };

  const handleViewDetail = (row) => {
    console.log({ row });
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    getSettingsData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  if (menuAccess)
    return (
      <SettingListTemplateComponent
        templateModal={{
          tableTitle,
          keyColumn,
          breadCrumbs,
          tableColumn,
          tableData,
          totalCount,
          filters: filters ? filters : rawFilters,
          tableActions: additionalActions({ handleViewDetail }),
        }}
        templateEvents={{
          getSettingsData,
          handleCreateClick,
          deleteRecords,
          handleDownload,
          submitFilter,
        }}
      />
    );

  return <PermissionDeniedComponent />;
};

export default SettingListComponent;
